import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'defaultGreetingText'
	| 'deepResearchGreetingText'
	| 'taskModeGreetingText'
	| 'taskModeDesignRefreshGreetingText';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		defaultGreetingText: {
			id: 'rovo-chat.rovo-greeting.default-greeting-text',
			defaultMessage: 'How can I help, {name}?',
			description:
				'The default text displayed in the Rovo Greeting to prompt the user to ask a question.',
		},
		deepResearchGreetingText: {
			id: 'rovo-chat.rovo-greeting.deep-research-greeting-text',
			defaultMessage: "Let's go in-depth",
			description: 'The text displayed in the Rovo Greeting to prompt the user to ask a question.',
		},
		taskModeGreetingText: {
			id: 'rovo-chat.rovo-greeting.task-mode-greeting-text',
			defaultMessage: "Let's check something off your list",
			description:
				'The text displayed in the Rovo Greeting when task mode is enabled, prompting the user to start a task.',
		},
		taskModeDesignRefreshGreetingText: {
			id: 'rovo-chat.rovo-greeting.task-mode-design-refresh-greeting-text',
			defaultMessage: "Let's plan your next move",
			description:
				'The text displayed in the Rovo Greeting when task mode is enabled with the design refresh, prompting the user to plan.',
		},
	});

export default message;
